<template>
  <div
    v-if="description"
    class="c-disclaimer"
  >
    <div class="l-container">
      <wysiwyg
        v-if="description"
        html="description"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Disclaimer",
  props: {
    description: {
      type: String,
      default: null
    },
  }
}
</script>

<style lang="scss" scoped>
.c-disclaimer {
  padding: $section-padding;
  text-align: center;
}
</style>

